import React from "react";
import { SideBarMenu } from "../Utils/SideBar/SideBar";
import { Outlet} from "react-router-dom";


export const ReportesCorresponsaliasDashboard: React.FC = () => {
    
    return (
        <div className="container-fluid mt-1">
            <div className="row flex-nowrap px-1">
                <SideBarMenu/>
                <Outlet/>
            </div>
        </div>
    )
}